






import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

@Component
class Index extends Vue {
  @State(state => state.app.layout) layout;

  checking = true;

  mounted() {
    const logged = this.$store.getters["auth/isLogged"];
    const route = this.$route.name ?? "";
    const isLogining = route.includes("basis-auth");

    if (!logged && !isLogining) {
      this.$common.utils.helper.requestToLoginPage(this);
    }
    this.checking = false;
  }
}
export default Index;
